import React from 'react'
import {ChevronLeft, ChevronRight, CrossIcon} from 'assets/icons'
import 'styles/main.scss'

const SlideOverHeader = ({children, hide, hideShow, navigation, extraActions}) => {

    return (
        <>
            <div className="flex justify-between p-5 gap-5">
                <h3 className="ft-lg tab:ft-2xl text-[#202124] font-semibold my-auto flex-1 min-w-0">
                    {children}
                </h3>
                <div className="flex items-center gap-2 my-auto">
                    {navigation && navigation.total > 1 && (
                        <div className="flex items-center gap-2">
                            <button
                                type={'button'}
                                onClick={navigation.onPrevious}
                                disabled={navigation.currentIndex === 0}
                                className="flex items-center justify-center border rounded p-1 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                            >
                                <ChevronLeft wh={20} color={'#374151'} />
                            </button>
                            <span className="text-sm text-gray-600 min-w-[40px] text-center">
                                {navigation.currentIndex + 1}/{navigation.total}
                            </span>
                            <button
                                type={'button'}
                                onClick={navigation.onNext}
                                disabled={navigation.currentIndex === navigation.total - 1}
                                className="flex items-center justify-center border rounded p-1 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                            >
                                <ChevronRight wh={20} color={'#374151'} />
                            </button>
                        </div>
                    )}
                    {extraActions}
                    <button
                        type={'button'}
                        className="flex items-center justify-center border rounded p-1"
                        onClick={hide}
                    >
                        <CrossIcon wh={20} color={'#111827'}/>
                    </button>
                </div>
            </div>
        </>
    )
}

export default SlideOverHeader